'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var disabled = _ref.disabled,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm;
  return {
    root: (0, _merge2.default)({
      width: rhythm(2),
      textAlign: 'center',
      opacity: disabled ? '0.2 !important' : 1,
      pointerEvents: disabled ? 'none' : 'all'
    }, styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/pagination-link/styles.js
// module id = 913
// module chunks = 0